import type { RefObject } from 'react';
import { useCallback, useEffect, useState } from 'react';

export function useWidgetsShadows({ containerRef }: { containerRef: RefObject<HTMLDivElement> }) {
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);

  const updateShadows = useCallback(() => {
    const el = containerRef.current;
    if (!el) {
      return;
    }

    const { scrollLeft, scrollWidth, clientWidth } = el;
    setShowLeftShadow(scrollLeft > 0);
    setShowRightShadow(scrollLeft + clientWidth < scrollWidth - 1);
  }, [containerRef]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    updateShadows();

    el.addEventListener('scroll', updateShadows, { passive: true });
    const resizeObserver = new ResizeObserver(updateShadows);
    resizeObserver.observe(el);

    return () => {
      el.removeEventListener('scroll', updateShadows);
      resizeObserver.disconnect();
    };
  }, [containerRef, updateShadows]);

  return { showLeftShadow, showRightShadow };
}
